import React from 'react';
import styles from '../UIGameBarbarianInvasionTracker.module.scss';
import { T, Tooltip } from '@colonist/ui';
import clsx from 'clsx';
import IconBarbarianShip from '@static/images/icon_barbarian_ship.svg';
const tooltipContent = [
    {
        key: 'strings:game.tips.barbarians.body.0'
    },
    {
        key: 'strings:game.tips.barbarians.body.1'
    }
];
export const UIGameBarbarianInvasionTrackerShip = ({ barbarianStrength, className })=>/*#__PURE__*/ React.createElement(Tooltip, {
        className: clsx(styles.iconWrapper, className),
        content: /*#__PURE__*/ React.createElement(React.Fragment, null, tooltipContent.map((item, i)=>/*#__PURE__*/ React.createElement("div", {
                className: styles.tooltipItem,
                key: i
            }, /*#__PURE__*/ React.createElement(T, {
                id: item
            })))),
        delay: 0,
        menuClassName: styles.tooltipMenu,
        position: "bottom-start",
        title: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.tips.barbarians.title'
            }
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: IconBarbarianShip
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.iconBadge
    }, /*#__PURE__*/ React.createElement("span", null, barbarianStrength)));
